export enum ErrorCode {
  VIDIS_0050 = 'VIDIS_0050',
  VIDIS_0100 = 'VIDIS_0100',
  VIDIS_0110 = 'VIDIS_0110',
  VIDIS_0120 = 'VIDIS_0120',
  VIDIS_0121 = 'VIDIS_0121',
  VIDIS_0122 = 'VIDIS_0122',
  VIDIS_0123 = 'VIDIS_0123',
  VIDIS_0124 = 'VIDIS_0124',
  VIDIS_0125 = 'VIDIS_0125 ',
  VIDIS_0126 = 'VIDIS_0126 ',
  VIDIS_0200 = 'VIDIS_0200',
  VIDIS_0290 = 'VIDIS_0290',
  VIDIS_0330 = 'VIDIS_0330',
  VIDIS_0340 = 'VIDIS_0340',
  VIDIS_0341 = 'VIDIS_0341',
}
